import {Action} from 'redux';
import {GET_LIVE_EVENTS} from "../../../constants/LiveConstants";

export const GetAlertsAction = (): Action => ({type: GET_LIVE_EVENTS});
